import { render } from "./MainMenu.vue?vue&type=template&id=881cc3c2"
import script from "./MainMenu.vue?vue&type=script&lang=js"
export * from "./MainMenu.vue?vue&type=script&lang=js"
script.render = render

export default script